import axios from 'axios';
import i18n from 'i18n';

const ipInfoLyon = {
  city: 'Lyon',
  region: 'Rhone-Alpes',
  asn: 'AS3215',
  continent_code: 'EU',
  country: 'FR',
  country_area: 547030,
  country_calling_code: '+33',
  country_capital: 'Paris',
  country_code: 'FR',
  country_code_iso3: 'FRA',
  country_name: 'France',
  country_population: 66987244,
  country_tld: '.fr',
  currency: 'EUR',
  currency_name: 'Euro',
  in_eu: true,
  ip: '',
  postal: null,
  region_code: null,
  languages: 'fr-FR',
  latitude: 45.753813,
  longitude: 4.832297,
  timezone: null,
  utc_offset: null,
  org: 'Orange',
};

// https://ipapi.co
export interface IpInfoType {
  ip: string;
  city: string; // Mountain View
  region: string; // California
  region_code: string | null; // CA
  country_code: string; // US
  country_code_iso3: string; // USA
  country_name: string; // Washington
  country_capital: string;
  country_tld: string;
  continent_code: string; // NA
  in_eu: boolean | null;
  postal: string | null;
  latitude: number; // 37.386;
  longitude: number; // -122.0838;
  timezone: string | null;
  utc_offset: string | null; // '-0800';
  country_calling_code: string;
  currency: string; // 'USD';
  currency_name: string; // 'Dollar';
  languages: string; // 'en-US,es-US,haw';
  asn: string; // 'AS15169';
  org: string; // 'Google LLC';
}
export const getIpInfo = async (): Promise<IpInfoType | null> => {
  try {
    const { data } = await axios.get('https://ipapi.co/json/', { timeout: 2000 });
    return data;
  } catch (_e) {
    return ipInfoLyon;
  }
};

export const switchUserLanguage = (ipInfo?: IpInfoType) => {
  if (ipInfo) {
    const isEn = ipInfo.languages.split(',').includes('en-US');
    const langId = isEn ? 'en' : 'fr';
    i18n.changeLanguage(langId);
  }
};
